import shortid from 'shortid'

const state = {
	messages: [],
	timeouts: {},
}

const getters = {
	getById: state => id => state.messages.find(m => m.id === id),
}

const mutations = {
	push(state, { toast, timeout }) {
		state.messages.push(toast)
		state.timeouts[toast.id] = timeout
	},
	pop(state, id) {
		state.messages = state.messages.filter(m => m.id !== id)
		if (state.timeouts[id]) {
			window.clearTimeout(state.timeouts[id])
			delete state.timeouts[id]
		}
	},
}

const actions = {
	push({ commit }, { message, severity = 'info', duration = 5000 }) {
		// Create toast
		const toast = { id: shortid(), message, severity }
		const timeout = window.setTimeout(() => commit('pop', toast.id), duration)
		// Push, then auto-remove toast after duration
		commit('push', { toast, timeout })
		return toast
	},
	pop({ getters, commit }, id) {
		const toast = getters.getById(id)
		commit('pop', id)
		return toast
	},
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true,
}
